import { render, staticRenderFns } from "./CustomFieldsModal.vue?vue&type=template&id=44243cbc&scoped=true&"
import script from "./CustomFieldsModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsModal.vue?vue&type=style&index=0&id=44243cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44243cbc",
  null
  
)

export default component.exports